// Screen `status` — owner: shell-nav (plan §3.1, §9.2). The human status page (no session needed).
import { createFileRoute } from '@tanstack/react-router';
import { StatusPage } from '../../features/ops/setup/StatusPage';

export const Route = createFileRoute('/_public/status')({
  component: StatusPage,
});
